//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getMenusWithArea from '~/gql/getMenusWithArea'
import Areas from '~/utils/areas'
export default {
  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      menuItems: [],
      menuItemButton: null,
      area: Areas.HEADER_MODERN,
      activeSubmenu: null,
      subMenuListensToMouseEvents: false,
    }
  },
  async fetch() {
    const response = await this.$graphcms.request(getMenusWithArea, {
      area: [Areas.HEADER_MODERN, Areas.USERLINKS_MODERN],
      lang: [this.$i18n.locale],
    })
    this.menuItems = response?.sectionMenus.filter(item => item.area.includes(Areas.HEADER_MODERN)).sort(function (a, b) {
      return a.priority - b.priority
    })
    this.menuItemButton = response?.sectionMenus.filter(item => item.area.includes(Areas.USERLINKS_MODERN))[0]
  },

  watch: {
    '$i18n.locale'() {
      this.$fetch()
    },
    $route() {
      this.subMenuListensToMouseEvents = false
    },
  },
  mounted() {
    document.addEventListener("click", this.handleLinkClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleLinkClick);
  },
  methods: {
    handleLinkClick(event) {
      const target = event.target.closest("a");
      if (target) {
        this.activeSubmenu = null
      }
    },
    openSubmenu(id) {
      if(this.activeSubmenu === id) {
        this.activeSubmenu = null
      } else {
        this.subMenuListensToMouseEvents = true
        this.activeSubmenu = id
      }
    },
    closeSubmenu() {
      this.activeSubmenu = null
    },
    getThemeColor(theme) {
      const themeData =
        this.$store.state.global.themes[theme] ??
        this.$store.state.global.themes.red
      return themeData.color
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
}
